import React, { useState, useEffect } from "react";
import { Container, Typography, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PostCard from "./PostCard";

const useStyle = makeStyles((theme) => ({
  headTextStyle: {
    textTransform: "uppercase",
    marginBottom: "1.5em",
    textAlign: "left",
  },
  marginSet: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
    },
  },
}));

const FooterRight = () => {
  const classes = useStyle();
  const [latestPost, setLatestPost] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchBlogUrl = `https://natakallam.com/wp-json/wp/v2/posts`;
    fetch(fetchBlogUrl)
      .then((resp) => resp.json())
      .then((blogs) => {
        setLatestPost(blogs.slice(0, 2));
        setLoaded(true);
      });
  }, []);

  if (loaded) {
    return (
      <Container className={classes.marginSet}>
        <Typography className={classes.headTextStyle} color="secondary">
          Latest Posts
        </Typography>
        {latestPost.map((post) => {
          return (
            <PostCard
              key={post.id}
              postTitle={post.title.rendered}
              imgId={post.featured_media}
              postId={post.id}
            />
          );
        })}
      </Container>
    );
  }
  return <CircularProgress />;
};

export default FooterRight;
